import * as React from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../../../../../../BaseComponents';
import { useClearExchangeVariants } from '../../model/useClearExchangeVariants';
const ClearExchangeVariantsButton = ({ label, onClick }) => {
    const { t } = useTranslation('Exchange');
    const { onClearExchangeVariants } = useClearExchangeVariants();
    const onClickHandler = useCallback(() => {
        onClearExchangeVariants();
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [onClick, onClearExchangeVariants]);
    return (React.createElement(BaseButton, { variant: "text", onClick: onClickHandler }, label || t('ClearExchangeVariantsButton.Label')));
};
export default ClearExchangeVariantsButton;
